import React, { useState } from 'react';
import { HelpCircle as HelpCircleIcon } from 'lucide-react';

const HelpCircle = ({ content, children }) => {
    const [showTooltip, setShowTooltip] = useState(false);

    return (
        <div className="relative inline-block">
            {children}
            <span
                className="ml-1 cursor-help inline-flex"
                onMouseEnter={() => setShowTooltip(true)}
                onMouseLeave={() => setShowTooltip(false)}
            >
        <HelpCircleIcon size={16} className="text-gray-400" />
      </span>
            {showTooltip && (
                <div className="absolute z-10 w-64 p-2 mt-2 text-sm text-white bg-gray-800 rounded-lg shadow-lg">
                    {content}
                </div>
            )}
        </div>
    );
};

export default HelpCircle;
